if (!customElements.get('backup-swatch')) {
  customElements.define(
    'backup-swatch',
    class BackupSwatch extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        fetch(`${this.dataset.url}&section_id=product-swatch`)
          .then((response) => response.text())
          .then((responseText) => {
            // get HTML of the target product's options
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            )
            const swatch = html.querySelector('div')
            this.innerHTML = swatch.innerHTML
          })
      }
    }
  )
}
